import { reducer as formReducer } from 'redux-form'

import { states, Config, Samples, Samplesets, Datasets, MDSS, Tasks, Jobs } from 'webmango-core/state'
import Processes from 'webmango-core/state/process'
import Sync from 'webmango-core/state/sync'

import Logout from './components/Logout/state'
import Search from './components/Search/state'

export default function () {
  const reducers = {
    config: Config,
    sync: Sync,
    logout: Logout,
    processes: Processes,
    search: Search,
    samples: Samples,
    datasets: Datasets,
    samplesets: Samplesets,
    form: formReducer,
    tasks: Tasks,
    jobs: Jobs,
    mdss: MDSS
  }

  states.forEach((value, key) => {
    reducers[key] = value
  })
  return reducers
}



// WEBPACK FOOTER //
// ./src/reducers.js